/**
 * @fileoverview Generic dashboard section component with title
 */

import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

/**
 * DashboardSection - A reusable section wrapper with title
 */
export const DashboardSection = ({ title, children, sx = {} }) => {
    return (
        <Box sx={{ mb: { xs: 3, md: 4 }, ...sx }}>
            {title && (
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    {title}
                </Typography>
            )}
            {children}
        </Box>
    );
};

DashboardSection.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
    sx: PropTypes.object
};
